module.exports = __webpack_public_path__ + "img/banner_7.0777f059.jpg";